import { all } from 'redux-saga/effects';

import consultarCidadaoAutista from './consultarCidadaoAutista/saga';
import cadastrarCidadaoAutista from './cadastrarCidadaoAutista/saga';
import atualizarCidadaoAutista from './atualizarCidadaoAutista/saga';

export default all([
	consultarCidadaoAutista,
	cadastrarCidadaoAutista,
	atualizarCidadaoAutista,
]);
